import React,{useState} from 'react';
import {css} from 'emotion';
import Logo from './components/Logo';
import StepOne from './components/step/step-one';
import ModalError from './components/ModalError';
import ModalValid from '../common/modal-valid';
import {useSelector,useDispatch} from 'react-redux';
import history from '../../utils/history';

const SigIn = (props)=>{
  const dispatch = useDispatch();
  const error = useSelector(state=>state.user.error_signin);
  const valid = useSelector(state=>state.user.valid_signin);

  const onReturn = () =>{
    history.goBack();
  }
  const goToHomePage = () =>{
    dispatch({type:'CLEAR_VALID_SIGN_IN'});
    history.push({pathname:'/'});
  }

  const onClose = () =>{dispatch({type:'CLEAR_ERROR_SIGN_IN'})}
    return (
      <div className={css`width:100vw;height:100vh;`}>
        <div className={css`height:120px;width:100%;background-color:#0085C6`}></div>
        <div className={css` @media (max-width: 678px) {
                width:100%;
                };width:500px;height:500px;margin:0 auto;margin-top:-100px;`}>
          <div className={css`display:flex;align-items:center`}>
            <div className={css`flex:1;display:flex;`}>
            <div className={css`flex:1;display:flex;justify-content:flex-start`}><Logo/></div>
              <div className={css`border-radius:10px;flex:1;justify-content:flex-end;display:flex;color:white;padding-right:20px;box-sizing:border-box;align-items:center;`}>
              <div onClick={onReturn} className={css`cursor:pointer;border:1px solid white;padding-top:5px;padding-bottom:5px;padding-right:10px;padding-left:10px;&:hover{background-color:white;color:#0085C6;}`}>Retour</div></div>
          </div>
          </div>
          <StepOne/>


        </div>
        {error && <ModalError onClose={onClose} message={error}/> }
        {valid && <ModalValid onClose={goToHomePage} message={'Inscription reussie !'}/>}
      </div>
    )
}

export default SigIn
